import { render, staticRenderFns } from "./ResultNumber.vue?vue&type=template&id=0dccd379&scoped=true&"
import script from "./ResultNumber.vue?vue&type=script&lang=js&"
export * from "./ResultNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dccd379",
  null
  
)

export default component.exports